import React, { useState, useEffect } from 'react';
import {postToHub} from "../../actions/networkActions";
import {onLoginSuccess} from "../../actions/authenticationActions";
import {store} from "../../App";
import {getExternalDashboardUrl, getTradePortalUrls} from "../../utils/configUtils";
import {getBackToDashboardText} from "../../utils/themeUtils";
import BackLink from "../../components/BackLink";
import { Trans, useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';
import { useParams, useSearchParams } from 'react-router';

function SessionIdLogin(props) {
    const {sessionId, successUrl} = useParams();
    const [searchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(true);
    const {t} = useLingui();

    // the validated trade portal urls if the link came from the trade portal, null if not
    const tradePortal = getTradePortalUrls(searchParams);

    // log in with the session token, then hand over to the router
    useEffect(() => {
        const fetchData = async function() {
            // a 403 here rejects the link's token, not the session already in the store, so show the error screen instead of logging that session out
            // hub is currently returning 400 on failed/missing/expired session id at the moment so this is only future proofing
            const response = await postToHub({path: "authentication/loginBySessionToken", headers:{SessionId: sessionId}, logoutOn403: false}, {});
            if(response.sessionId) {
                // no need to setLoading state here as this component gets unmounted when navigate() function takes user to next page
                onLoginSuccess(store.dispatch, {...response, ignoreAgency: true, tradeportal: tradePortal});
                navigate(successUrl === t({id: "itinerary"}) ? t({id: "/itinerary"}) : t({id: "/dashboard"}));
            }
            else {
                setIsLoading(false);
            }
        }

        fetchData();
    }, []);

    // divs have set keys, in order for react to drop the div and mount a fresh one in case there is an error with the login
    // as reusing it might cause issues in some edge cases with page translators
    if(isLoading) {
        return (
            <div key="loading" className="container mx-auto mt-6">
                <span translate="no"><Trans id='loading'>loading</Trans>...</span>
            </div>
        )
    }

    // this will only ever show if there was an error, on success the navigation happens and user is taken to another route
    const backUrl = tradePortal?.bookingUrl || getExternalDashboardUrl();
    return (
        <div key="error" className="container mx-auto mt-6">
            <div>
                <Trans id="error_with_login_try_again">There has been an error with your login, please try again.</Trans>
            </div>
            {backUrl &&
            <div className="mt-4">
                <BackLink to={backUrl} isExternal={true} text={getBackToDashboardText(!!tradePortal)}/>
            </div>}
        </div>
    );
}

export default SessionIdLogin;